import type { JSXElementConstructor } from 'react'
import { always } from 'ramda'

import { OrderType } from '~/constants/SOAPStates'
import InventoryItemActions from '~/utils/actions/InventoryItemActions'
import LabTestActions from '~/utils/actions/LabTestActions'
import PrescriptionItemActions from '~/utils/actions/PrescriptionItemActions'
import ProcedureActions from '~/utils/actions/ProcedureActions'
import TaskOrderActions from '~/utils/actions/TaskOrderActions'
import InventoryItemContent from '~/utils/content/InventoryItemContent'
import LabTestContent from '~/utils/content/LabTestContent'
import PrescriptionItemContent from '~/utils/content/PrescriptionItemContent'
import ProcedureContent from '~/utils/content/ProcedureContent'
import InventoryItem from '~/utils/InventoryItem'
import LabTest from '~/utils/LabTest'
import PrescriptionItem from '~/utils/PrescriptionItem'
import Procedure from '~/utils/Procedure'
import TaskOrder from '~/utils/TaskOrder'

export const OrderComponents: Partial<
  Record<OrderType, JSXElementConstructor<any>>
> = {
  [OrderType.INVENTORY]: InventoryItem,
  [OrderType.PROCEDURE]: Procedure,
  [OrderType.LAB_TEST]: LabTest,
  [OrderType.PRESCRIPTION]: PrescriptionItem,
  [OrderType.TASK]: TaskOrder,
}

export const OrderComponentsActions: Partial<
  Record<OrderType, JSXElementConstructor<any>>
> = {
  [OrderType.INVENTORY]: InventoryItemActions,
  [OrderType.PROCEDURE]: ProcedureActions,
  [OrderType.LAB_TEST]: LabTestActions,
  [OrderType.PRESCRIPTION]: PrescriptionItemActions,
  [OrderType.TASK]: TaskOrderActions,
}

export const OrderComponentsContents: Partial<
  Record<OrderType, JSXElementConstructor<any>>
> = {
  [OrderType.INVENTORY]: InventoryItemContent,
  [OrderType.PROCEDURE]: ProcedureContent,
  [OrderType.LAB_TEST]: LabTestContent,
  [OrderType.PRESCRIPTION]: PrescriptionItemContent,
  [OrderType.TASK]: always(null),
}
